import StarView from './StarView';
const { featureManager } = window;

export default class StarRating extends Backbone.View {
    events() {
        return {
            'mouseleave': 'stopHoverRating'
        };
    }

    remove() {
        this._views.forEach((view) => view.remove());
        super.remove();
    }

    get isEnabled() {
        return !this.model.get('isPreReleaseTitle');
    }

    constructor() {
        super(...arguments);
        this._views = [];
        this.hoverRating = 0;
        this.$el.addClass('star-ratings-container StarRatings');

        this.rid = Math.random().toString(36).substring(7);

        // Update star rating when patron status is received
        this.listenTo(this.model, 'change:userStarRating', (model) => {
            this.update();
        });
    }

    render() {
        if(!this.isEnabled) {
            return this;
        }

        let globalRating = this.model.get('starRating') || 0;
        this.$el.attr('data-global-rating', this.model.get('starRating'));
        this.$el.attr('data-media-id', this.model.id);

        this._views.forEach((view) => view.remove());
        this._views.length = 0;

        let ctx = this;
        _.each([1, 2, 3, 4, 5, 0], (index) => {
            let viewData = {
                index: index,
                globalRating: globalRating,
                rid: this.rid
            };
            let starView = new StarView(viewData);
            
            if (!featureManager.isEnabled('internationalDemoMode')){
                starView.on('rate', (starValue) => {
                    ctx.handleRating(starValue);
                });
                starView.on('hover', (starValue) => {
                    ctx.onHoverRating(starValue);
                });
            }
            
            this._views.push(starView);
        });

        this.$el.empty();
        this._views.forEach((view) => {
            view.render();
            this.$el.append(view.$el);
        });
        this.update();

        return this;
    }

    isHalfStar (globalRating) {
        return globalRating % 1 >= 0.25 && globalRating % 1 < 0.75; 
    }

    update() {
        if (!this.isEnabled) {
            return this;
        }

        let isUserRating = (this.model.get('userStarRating') > 0 || this.hoverRating) > 0;
        this.$el.toggleClass('user-rating', isUserRating);
        let globalRating = this.model.get('starRating') || 0;

        _.each(this._views, (starView) => {

            if (isUserRating){
                starView.setFilled(starView.index <= (this.hoverRating || this.model.get('userStarRating')));
            } else if (starView.index < globalRating) {
                starView.setFilled(true);
            } else if (starView.index - 1 > globalRating) {
                starView.setFilled(false);
            } else {
                starView.setFilled(starView.index - 0.75 < globalRating, this.isHalfStar(globalRating));
            }
            starView.$el.children('.starRadio').prop('checked', starView.index === this.model.get('userStarRating'));
        });

        return this;
    }

    handleRating(starValue) {
        let currentRating = this.model.get('userStarRating');
        if (starValue === currentRating) {
            this.model.set('userStarRating', 0);
            this.stopHoverRating();
        }
        else {
            this.model.set('userStarRating', starValue);
        }
        this.model.trigger('title:action', { action: 'rating', model: this.model });
    }

    onHoverRating(starValue) {
        this.hoverRating = starValue;
        this.update();
    }

    stopHoverRating() {
        this.hoverRating = 0;
        this.update();
    }
}
